import { TopCitiesSelling } from "common/data"
import React from "react"
import { Card, CardBody, CardTitle, Progress } from "reactstrap"

const TopCities = ({ data }) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">
            Top Countries(No.of Registration)
          </CardTitle>

          <div className="table-responsive mt-4">
            <table className="table align-middle table-nowrap">
              <tbody>
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ width: "30%" }}>
                      <p className="mb-0">{item.country}</p>
                    </td>
                    <td style={{ width: "25%" }}>
                      <h5 className="mb-0">{item.count}</h5>
                    </td>
                    <td>
                      <Progress
                        value={item.percentage}
                        color={"#E4661D"}
                        className="bg-transparent progress-sm"
                        size="sm"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default TopCities
